import React from 'react';

const SideBar = props => {
  return <div style={{ height: '100%', backgroundColor: props.color }} />;
};

SideBar.propTypes = {};

export default SideBar;
